import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Pivot = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="pivot icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M0 2C0 0.89543 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V8.5C24 9.60457 23.1046 10.5 22 10.5H2C0.89543 10.5 0 9.60457 0 8.5V2Z"
    />
    <path
      className={pathClass}
      d="M0 15.5C0 14.3954 0.895431 13.5 2 13.5H8.5C9.60457 13.5 10.5 14.3954 10.5 15.5V22C10.5 23.1046 9.60457 24 8.5 24H2C0.89543 24 0 23.1046 0 22V15.5Z"
    />
    <path
      className={pathClass}
      d="M13.5 15.5C13.5 14.3954 14.3954 13.5 15.5 13.5H22C23.1046 13.5 24 14.3954 24 15.5V22C24 23.1046 23.1046 24 22 24H15.5C14.3954 24 13.5 23.1046 13.5 22V15.5Z"
    />
  </svg>
)
